var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFaceBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2552 20.0265C39.2552 29.7522 32.0481 37.7926 22.6855 39.0973C21.8101 39.2188 20.9144 39.2822 20.0052 39.2822C18.9558 39.2822 17.9253 39.1985 16.9217 39.0366C7.75464 37.5605 0.753906 29.6105 0.753906 20.0265C0.753906 9.39147 9.37331 0.769531 20.0039 0.769531C30.6345 0.769531 39.2552 9.39147 39.2552 20.0265Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.685 16.2319V20.4269H27.8729L27.0514 26.0777H22.685V39.097C21.8096 39.2184 20.9139 39.2818 20.0048 39.2818C18.9554 39.2818 17.9248 39.1982 16.9212 39.0362V26.0777H12.1367V20.4269H16.9212V15.2942C16.9212 12.1099 19.5017 9.52734 22.6864 9.52734V9.53004C22.6958 9.53004 22.7039 9.52734 22.7134 9.52734H27.8742V14.4145H24.502C23.4998 14.4145 22.6864 15.2281 22.6864 16.2306L22.685 16.2319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaceBook);
export default __webpack_public_path__ + "static/media/IconFaceBook.4dfd0f7580e829b1a58b135aba6efb9e.svg";
export { ForwardRef as ReactComponent };